
import React from "react";
import ReactDOM from "react-dom";

import App from "./app"
//const history = createBrowserHistory()

ReactDOM.render(  
    <App />, 
  document.getElementById("app"));